import styled from "styled-components";

export const Hint = styled.p`
  max-width: 420px;
  color: #7f8087;
  font-size: 13px;
`;
